import styled, { css } from 'styled-components';

import { ButtonStyled } from '../Button/Button.styled';
import Paper from '../Paper/Paper.styled';

type DropdownHeaderPropsT = {
  isArrowVisible?: boolean;
  isOpen: boolean;
};

export const DropdownWrapStyled = styled(Paper)`
  width: 100%;
`;

export const DropdownBodyStyled = styled.div`
  display: flex;
  gap: 10px;
  border-top: 1px solid #dbdbdb;
  padding: 20px;

  & > ${ButtonStyled} {
    align-self: flex-start;
    flex: none;
  }

  & > *:first-child {
    width: 100%;
  }
`;

export const DropdownHeaderStyled = styled.button<DropdownHeaderPropsT>(
  ({ isArrowVisible, isOpen }) => css`
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 5px;

    padding: 15px 20px;
    text-align: left;

    & > * {
      width: 100%;
    }

    ${isArrowVisible &&
    `
      &::before {
        content: '';
        display: inline-block;
        border-bottom: 2px solid #ac8364;
        border-right: 2px solid #ac8364;
        height: 10px;
        width: 10px;
        margin-top:  ${isOpen ? '5px' : '-5px'};
        transform: ${isOpen ? 'rotate(-135deg)' : 'rotate(45deg)'};
      }
    `}
  `
);
